import Tooltip from './Tooltip';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-tooltip').forEach(control => {
    const tooltip = new Tooltip(control);
    tooltip.mount();
  });
});
